import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useContext, useEffect, useState } from 'react';
import { overrideContext } from './context';
export var OverrideRegistryRoot = function OverrideRegistryRoot(_ref) {
  var children = _ref.children,
    overrides = _ref.overrides;
  var _useState = useState(function () {
      return new Map(overrides);
    }),
    _useState2 = _slicedToArray(_useState, 1),
    registry = _useState2[0];
  useEffect(function () {
    var callbacks = overrides.map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        subject = _ref3[0],
        target = _ref3[1];
      return addCommerceOverride(registry, subject, target);
    });
    return function () {
      return callbacks.forEach(function (cb) {
        return cb();
      });
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  overrides);
  return /*#__PURE__*/React.createElement(overrideContext.Provider, {
    value: registry
  }, children);
};
export var useOverrideRegistry = function useOverrideRegistry() {
  return useContext(overrideContext);
};
/**
 * adds an override for an entity
 * @param registry
 * @param subject
 * @param override
 * @returns {Function} cancellation function
 */
export var addCommerceOverride = function addCommerceOverride(registry, subject, override) {
  registry.set(subject, override);
  return function () {
    registry.delete(subject);
  };
};

/**
 * returns a possible mocked subject
 * @param subject
 * @returns subject
 *
 * @example
 * const thing = () => {};
 * addCommerceOverride(registry, thing, anotherThing);
 * // ...
 * withCommerceOverride(registry, thing) === anotherThing
 */
export var withCommerceOverride = function withCommerceOverride(registry, subject) {
  return registry.get(subject) || subject;
};
export var useCommerceOverride = function useCommerceOverride(subject) {
  var registry = useOverrideRegistry();
  return (registry || new Map()).get(subject) || subject;
};
export var asCommerceOverride = function asCommerceOverride(subject, target) {
  return [subject, target];
};